<template>
  <v-text-field
        v-model="search"
        label="Search"
        prepend-inner-icon="mdi-magnify"
        variant="outlined"
        hide-details
        single-line
      ></v-text-field>
  <v-data-table
    :headers="headers"
    :items="tableData"
    item-key="id"
    :search="search"
    v-model:sort-by="sortBy"
    class="department-table"
  >
    <template #item.action="{ item }">
      <v-btn
        size="small"
        variant="text"
        icon="mdi-pencil"
        :aria-label="`Edit ${item.name}`"
        @click="onClick(item)"
      />

      <v-btn
        size="small"
        variant="text"
        color="error"
        icon="mdi-delete"
        :aria-label="`Delete ${item.name}`"
        @click="onClickDelete(item)"
      />
    </template>
  </v-data-table>
</template>

<script setup>
import { ref , computed} from 'vue'
const props = defineProps({
  items: Array,
  entityType: String
})

const tableData = computed(() => {
  if(props.entityType === "users"){
    return props.items.map(user => {
      return {
        name: user.username,
        path: user.department?.path || user.company?.path || user.organisation?.path || null,
        id: user.id,
      }
    }
   )
  }
  else return props.items
})

const emit = defineEmits(['edit', 'delete'])


const headers = [
  { title: 'NAME', key: 'name', align: 'start',},
  { title: 'PATH', key: 'path' },
  { title: 'ACTION', key: 'action', sortable: false }
]

const onClick = (item) => {
  emit('edit', item)
}

const onClickDelete = async ({id}) => {
    emit('delete', id)
}

const search = ref('')
const sortBy = ref([{ key: 'carbs', order: 'asc' }])

</script>

<style scoped>
.department-table :deep(tbody tr) {
  transition: all 0.2s ease;
}

.department-table :deep(tbody tr:hover) {
  background-color: rgba(0, 0, 0, 0.03);
  cursor: pointer;
}
</style>